export default __webpack_public_path__ + "static/media/Unionhead.065bd18a.svg";